import React from "react";
import Logo from '../../../assets/Logo-02.png';
import FooterQR from '../../../assets/footerQR.png';
import Logo40th from '../../../assets/Logo 40th 1.png';
import Bunga from '../../../assets/Bunga.png';
import moment from "moment";
import Barcode from 'react-barcode';
import ReactHtmlParser from 'react-html-parser';
import 'moment/locale/id';
moment.locale('id');

export class ComponentToPrint extends React.PureComponent {
  render() {
    // alert(this.props.item.SURAT_SAKIT_HARI)
    const numberFormat = (value) =>
      new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value);

    console.log("ini printan surat sakit", this.props.item)


    var birthdateTimeStamp = new Date(this.props.item.TANGGAL_LAHIR);
    var cur = new Date();
    var diff = cur - birthdateTimeStamp;
    var currentAge = Math.floor(diff / 31557600000);
    var word1 = this.props.item.NAMA_DOKTER.length;
    var word1Length = '';

    if (word1 > 46) {
      word1Length = '1.8vw';
    } else if (word1 <= 46 && word1 >= 34) {
      word1Length = '2.5vw';
    } else {
      word1Length = '3vw';
    }

    var word2 = this.props.item.SIP.length;
    var word2Length = '';

    if (word2 > 46) {
      word2Length = '1.8vw';
    } else if (word2 <= 46 && word2 >= 30) {
      word2Length = '2.5vw';
    } else {
      word2Length = '3vw';
    }

    // alert(word2);


    return (
      <div className='hide-print'>
        <div
          className="container-fluid"
          style={{
            // maxWidth: "1240px",
            // maxHeight: "874px",
            // backgroundImage: 'url(' + { Bunga } + ')',
            // backgroundPosition: 'center',
            // backgroundRepeat: 'no-repeat',
            // backgroundSize: 'cover',

          }}
        >
          <div id="ui-view" data-select2-id="ui-view">
            <div>
              <div className="card" >
                <div className="card-body">
                  {/* <div className="row" style={{
                    // border: "0.5px solid #707070",
                    marginTop: '0px',
                    marginBottom: 10
                  }}>
                    <div className="col=12" style={{}}>
                      <table style={{ width: '100%' }}>
                        <tbody>
                          <tr>
                            <td>
                              <p style={{ textAlign: 'center' }}>
                                <img
                                  src={Logo}
                                  width="420"
                                  alt="Logo"
                                  style={{
                                    // padding: 20,
                                    // display: "block",
                                  }}
                                />
                              </p>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <p
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "22px",
                                  textAlign: 'center',
                                  marginBottom: '0px'
                                }}
                              >{this.props.item.branch_alamat}</p>

                              <p
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "22px",
                                  textAlign: 'center',
                                  marginTop: '0px',
                                }}
                              >Telp. {this.props.item.branch_notelp}</p>
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </div> */}

                  <div className="row"
                    style={{
                      // border: "0.5px solid #707070",
                      marginTop: '20px',
                      // marginBottom: 10
                    }}>

                    <div className="col-4"
                    // style={{ border: '1px solid red' }}
                    >
                      <table
                      // style={{ width: '100%' }}
                      >
                        <tbody>
                          <tr>
                            <td>
                              <img
                                src={Logo}
                                width="100%"
                                alt="Logo"
                                style={{
                                  // padding: 20,
                                  // paddingTop: 20,
                                  // display: "block",
                                }}
                              />
                            </td>
                          </tr>



                        </tbody>
                      </table>
                    </div>

                    <div className="col-8"
                    // style={{ width: "100%" }}
                    // style={{ border: '1px solid red' }}
                    >
                      <div style={{
                        // float: "right",
                        fontFamily: "Montserrat",
                        marginRight: '24px'
                        // fontSize: "14px",
                      }}>

                        <table style={{
                          float: "right",
                          // border: '1px solid blue'
                        }}>
                          <tbody>

                            <tr>
                              <td>
                                <div style={{
                                  width: '100%',
                                  // border: '1px solid black',
                                  fontSize: word1Length,
                                  margin: '20px',
                                  textAlign: 'right',
                                  marginTop: '-2px',
                                  fontWeight: 'bold'
                                }}>
                                  {this.props.item.NAMA_DOKTER}
                                </div>
                              </td>

                            </tr>
                            <tr>
                              <td>
                                <div style={{
                                  width: '100%',
                                  // border: '1px solid black',
                                  fontSize: word2Length,
                                  margin: '20px',
                                  textAlign: 'right',
                                  marginTop: '-12px'
                                }}>
                                  SIP : NO.{this.props.item.SIP}

                                </div>
                              </td>



                            </tr>

                          </tbody>
                        </table>


                      </div>
                    </div>


                  </div>

                  <div style={{ width: '100%', borderWidth: '0.5px', borderBottom: '0.5px solid #707070' }}></div>

                  <div className="row" style={{
                    // border: "0.5px solid #707070", 
                    marginTop: '0px'
                  }}>
                    <div className="col=12" style={{}}>

                      {/* <hr style={{ border: "0.5px solid #707070", marginTop: '0px' }} /> */}

                      <form
                        style={{
                          padding: "0px 20px 0px 20px",
                          fontFamily: "Montserrat",
                          marginBottom: 20

                        }}
                      >

                        <div className="row">

                          <div className="col-12">
                            <p
                              style={{
                                lineHeight: "42px",
                                fontSize: 38,
                                textAlign: "center",
                                marginTop: 40,
                                fontWeight: 'bold',
                                textDecoration: 'underline',
                                textUnderlineOffset: '8px',
                                textDecorationThickness: '1px',
                                // borderBottom: "1px solid rgb(212, 212, 212)"
                              }}
                            >
                              SURAT KETERANGAN SAKIT
                            </p>
                            {/* <div style={{ width: '100%', borderWidth: '0.5px', borderBottom: '0.5px solid #707070' }}></div> */}
                            <p
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                textAlign: "justify",
                                marginTop: 30,
                                marginBottom: '8px'
                              }}
                            >
                              Dengan ini menerangkan bahwa berdasarkan hasil pemeriksaan yang telah dilakukan kepada pasien :
                            </p>
                            {/* <p
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                textAlign: "justify",
                                marginBottom: '8px'
                              }}
                            >
                              dilakukan kepada pasien :
                            </p> */}
                          </div>

                        </div>


                      </form>

                      <form
                        style={{
                          padding: "0px 20px 0px 20px",
                          fontFamily: "Montserrat",
                          // marginTop: "24px",
                        }}
                      >

                        <div className="row mb-2">
                          <div className="col-3">
                            <label
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                textAlign: "left",
                              }}
                            >
                              Nama
                            </label>
                            {/* <p>Name</p> */}
                          </div>
                          <div className="col-9">
                            <label
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                fontWeight: "500",
                              }}
                            >
                              :{" "}{this.props.item.NAMA_PASIEN}
                            </label>
                          </div>
                        </div>

                        {/* <div className="row mb-2">
                          <div className="col-3">
                            <label
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                textAlign: "left",
                              }}
                            >
                              Jenis Kelamin
                            </label>
                          </div>
                          <div className="col-9">
                            <label
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                fontWeight: "500",
                              }}
                            >
                              :{" "}{this.props.item.JENIS_KELAMIN}
                            </label>
                          </div>
                        </div> */}

                        <div className="row mb-2">
                          <div className="col-3">
                            <label
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                textAlign: "left",
                              }}
                            >
                              NO. MR
                            </label>
                            {/* <p>Age</p> */}
                          </div>
                          <div className="col-9">
                            <label
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                fontWeight: "500",
                              }}
                            >
                              :{" "}{this.props.item.NOMR}
                            </label>
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-3">
                            <label
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                textAlign: "left",
                              }}
                            >
                              Umur
                            </label>
                            {/* <p>Age</p> */}
                          </div>
                          <div className="col-9">
                            <label
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                fontWeight: "500",
                              }}
                            >
                              :{" "}{currentAge + " Tahun"}
                            </label>
                          </div>
                        </div>

                        <div className="row mb-2">
                          <div className="col-3">
                            <label
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                textAlign: "left",
                              }}
                            >
                              Pekerjaan
                            </label>
                            {/* <p>Weight</p> */}
                          </div>
                          <div className="col-9">
                            <label
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                fontWeight: "500",
                              }}
                            >
                              :{" "}{this.props.item.PEKERJAAN}
                            </label>
                          </div>
                        </div>


                        {/* <div className="row mb-2">
                      <div className="col-4">
                        <label
                          style={{
                            lineHeight: "42px",
                            fontSize: 24,
                            textAlign: "left",
                          }}
                        >
                          TTL
                        </label>
                      </div>
                      <div className="col-8">
                        <label
                          style={{
                            fontSize: 24,
                            fontWeight: "500",
                          }}
                        >
                          :{" "}{this.props.item.TEMPAT_LAHIR != "" ? this.props.item.TEMPAT_LAHIR + ", " + moment(this.props.item.TANGGAL_LAHIR).format("DD-MM-YYYY") : moment(this.props.item.TANGGAL_LAHIR).format("DD-MM-YYYY")}
                        </label>
                      </div>
                    </div> */}

                        <div className="row mb-2">
                          <div className="col-3">
                            <label
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                textAlign: "left",
                              }}
                            >
                              Alamat
                            </label>
                            {/* <p>Address</p> */}
                          </div>
                          <div className="col-9">
                            <table>
                              <tr>
                                <td style={{ verticalAlign: 'top', fontSize: 26, width: 10, lineHeight: "22px", }}>
                                  <p>:</p>
                                </td>
                                <td>
                                  <label
                                    style={{
                                      lineHeight: "30px",
                                      fontSize: 26,
                                      fontWeight: "500",
                                      textAlign: "justify",
                                    }}
                                  >
                                    {this.props.item.alamatPasien}
                                  </label>
                                </td>
                              </tr>

                            </table>


                          </div>
                        </div>



                      </form>

                      <form
                        style={{
                          padding: "0px 20px 0px 20px",
                          fontFamily: "Montserrat",
                          marginBottom: 80

                        }}
                      >

                        <div className="row">

                          <div className="col-12">

                            <p
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                textAlign: "justify",
                                marginBottom: '8px'
                              }}
                            >
                              Diberikan istirahat sakit selama
                              {" "}
                              {this.props.item.SURAT_SAKIT_HARI == 1 ? "satu" : null}
                              {this.props.item.SURAT_SAKIT_HARI == 2 ? "dua" : null}
                              {this.props.item.SURAT_SAKIT_HARI == 3 ? "tiga" : null}
                              {" "}
                              (<b>{this.props.item.SURAT_SAKIT_HARI}</b>) hari terhitung mulai tanggal <b>{moment(moment.utc(this.props.item.DATE_EXAM)).local().format("DD MMMM YYYY")}</b> s.d tanggal <b>{moment(moment.utc(this.props.item.DATE_EXAM).add(this.props.item.SURAT_SAKIT_HARI - 1, 'days')).local().format("DD MMMM YYYY")}</b>. Demikian surat keterangan ini diberikan untuk diketahui dan dipergunakan seperlunya.

                            </p>

                            {/* <p
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                textAlign: "justify",
                                marginBottom: '8px'
                              }}
                            >
                              Diberikan istirahat sakit selama .............. (....................... <b>{this.props.item.SURAT_SAKIT_HARI}</b> .......................) hari terhitung
                            </p>

                            <p
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                textAlign: "justify",
                                marginBottom: '8px'
                              }}
                            >
                              mulai tanggal <b>{moment(moment.utc(this.props.item.DATE_EXAM)).local().format("DD MMMM YYYY")}</b> s.d tanggal <b>{moment(moment.utc(this.props.item.DATE_EXAM).add(this.props.item.SURAT_SAKIT_HARI, 'days')).local().format("DD MMMM YYYY")}</b>
                            </p>

                            <p
                              style={{
                                lineHeight: "42px",
                                fontSize: 26,
                                textAlign: "justify",
                                marginBottom: '8px'
                              }}
                            >
                              Demikian surat keterangan ini diberikan untuk diketahui dan dipergunakan seperlunya.

                            </p> */}


                          </div>

                        </div>


                      </form>



                      {/* <hr style={{ border: "0.5px solid #707070", marginTop: 40 }} /> */}

                      <div className="row" style={{ marginBottom: 0 }}>
                        {/* <div className="col-6" > </div> */}
                        <div className="col-12" >
                          <table style={{ width: '100%', textAlign: 'right' }} >
                            <tr>
                              <td align="center">
                                <p
                                  style={{
                                    listStyleType: "number",
                                    lineHeight: "26px",
                                    padding: "0px 0px 0px 12px",
                                    // fontFamily: "var(--font-family-raleway-medium)",
                                    fontSize: "26px",
                                    textAlign: 'left',
                                    // fontStyle: 'italic',
                                    // borderBottom: "0.5px solid #707070",
                                  }}
                                >
                                  {this.props.item.branch_city}, {moment(moment.utc(this.props.item.DATE_EXAM)).local().format("DD MMMM YYYY")}
                                </p>
                              </td>
                            </tr>


                          </table>


                        </div>
                      </div>


                      <div className="row" style={{ marginBottom: 120}}>
                        {/* <div className="col-6"></div> */}
                        <div className="col-12">
                          <table style={{ width: '100%', textAlign: 'right', }} >
                            <tr>
                              <td align="center">
                                <p
                                  style={{
                                    listStyleType: "number",
                                    lineHeight: "26px",
                                    padding: "0px 0px 0px 12px",
                                    // fontFamily: "var(--font-family-raleway-medium)",
                                    fontSize: "26px",
                                    textAlign: 'left',

                                    // fontStyle: 'italic',
                                    // borderBottom: "0.5px solid #707070",
                                  }}
                                >
                                  Dokter Pemeriksa
                                </p>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>

                      <div className="row">
                        {/* <div className="col-6" > </div> */}
                        <div className="col-12" >
                          <table style={{ width: '100%', textAlign: 'right', }} >
                            <tr>
                              <td align="center">
                                <p
                                  style={{
                                    listStyleType: "number",
                                    lineHeight: "26px",
                                    padding: "0px 0px 0px 12px",
                                    // fontFamily: "var(--font-family-raleway-medium)",
                                    fontSize: "26px",
                                    fontWeight: "bold",
                                    textAlign: 'left',
                                    // fontStyle: 'italic',
                                    // borderBottom: "0.5px solid #707070",
                                  }}
                                >
                                  {this.props.item.NAMA_DOKTER}
                                </p>
                              </td>
                            </tr>

                            <tr>
                              <td align="center">
                                <p
                                  style={{
                                    listStyleType: "number",
                                    lineHeight: "26px",
                                    padding: "0px 0px 0px 12px",
                                    // fontFamily: "var(--font-family-raleway-medium)",
                                    fontSize: "26px",
                                    textAlign: 'left',
                                    // fontStyle: 'italic'
                                  }}
                                >
                                  No. SIP : {this.props.item.SIP}
                                </p>
                              </td>
                            </tr>
                          </table>


                        </div>
                      </div>

                    </div>
                  </div>


                  <div
                    className="footer fixed-bottom col-lg-12 col-sm-12 ml-auto"
                    style={{ paddingLeft: "40px", marginBottom: '40px', display: this.props.item.statusSelesai == "PERIKSA LAB" ? null : 'none' }}
                  >

                    <table style={{ width: '100%', textAlign: 'right', }} >
                      <tr>
                        <td align="center" style={{ width: '80px' }}>
                          <p style={{ textAlign: 'left', marginBottom: "0px", }}>
                            <img
                              src={FooterQR}
                              width="80"
                              alt="Logo"
                              style={{
                                // padding: 20,
                                // paddingTop: 20,
                                // display: "block",
                              }}
                            />
                          </p>
                        </td>

                        <td style={{}}>
                          <p
                            style={{
                              fontFamily: "Montserrat",
                              fontSize: "18px",
                              textAlign: 'left',
                              marginLeft: 10,
                              marginBottom: '0px'
                            }}
                          >
                            <span style={{ fontWeight: 'bold' }}>Klinik Utama Bio Medika : </span>
                            {this.props.item.branch_alamat}
                          </p>
                          <p
                            style={{
                              fontFamily: "Montserrat",
                              fontSize: "18px",
                              textAlign: 'left',
                              marginLeft: 10,
                              marginBottom: '0px'
                            }}
                          >
                            T {this.props.item.branch_notelp}
                          </p>
                          <p
                            style={{
                              fontFamily: "Montserrat",
                              fontSize: "14px",
                              fontStyle: "italic",
                              textAlign: 'left',
                              marginLeft: 10,
                              marginBottom: '0px',
                            }}
                          >
                            Silahkan scan QR untuk mendapatkan tambahan informasi mengenai lokasi dan layanan cabang kami.
                          </p>
                        </td>
                      </tr>
                    </table>
                  </div>

                  {/* <div
                    className="footer fixed-bottom col-lg-12 col-sm-12 "
                    style={{ paddingLeft: "40px", textAlign: 'right' }}
                  >

              

                  </div> */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}